<div class="spacerWrapper" fxLayout="column">
    <h2 mat-dialog-title class="dialogTitle">{{ title }}</h2>

    <div mat-dialog-content>
        <form [formGroup]="eventEditorForm">
            <div class="inputContainer">
                <label>EventName</label>
                <mat-form-field appearance="outline">
                    <input #eventName matInput type="text" formControlName="EventName" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>EventDesc</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="EventDesc" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>EventUrl</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="EventUrl" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>EventNotes</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="EventNotes" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>EventContact</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="EventContact" />
                </mat-form-field>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="CatCommunity" aria-label="CatCommunity"></mat-checkbox>
                <label> CatCommunity</label>
            </div>

            <!-- <div class="checkboxContainer">
                <mat-checkbox formControlName="CatDepartmentIt" aria-label="CatDepartmentIt"></mat-checkbox>
                <label> CatDepartmentIt</label>
            </div> -->

            <div class="checkboxContainer">
                <mat-checkbox formControlName="CatParents" aria-label="CatParents"></mat-checkbox>
                <label> CatParents</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="CatSchools" aria-label="CatSchools"></mat-checkbox>
                <label> CatSchools</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="CatStaff" aria-label="CatStaff"></mat-checkbox>
                <label> CatStaff</label>
            </div>

            <div class="checkboxContainer">
                <mat-checkbox formControlName="CatStudents" aria-label="CatStudents"></mat-checkbox>
                <label> CatStudents</label>
            </div>
        </form>
    </div>

    <div class="spacer" fxFlex></div>

    <div class="error-messages" fxLayout="column" fxLayoutAlign="start end">
        <mat-error *ngIf="EventName.invalid && !EventName.errors?.isNameTaken && EventName.touched">
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Please provide a name for the calendar event.
        </mat-error>
        <mat-error *ngIf="EventName.errors?.isNameTaken && EventName.touched">
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Event Name chosen is already in use.
        </mat-error>
    </div>

    <div mat-dialog-actions align="end">
        <button mat-raised-button type="submit" color="primary" (click)="onSubmit(eventEditorForm.value)">OK</button>
        <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
    </div>
</div>
